<template>
    <CModal title="Seguimiento del Premio" color="info" size="lg" :show.sync="showModal">
        <!-- === FORMULARIO === -->
        <CForm>
            <CRow>
                <CCol md="8">
                    <CInput label="Comentario" :value.sync="$v.form.comment.$model" :isValid="checkIfValid('comment')"
                        placeholder="Ej: Se realizó solicitud a Amazon..."
                        invalidFeedback="El comentario es requerido." />
                </CCol>
                <CCol md="4">
                    <label for="">Imagen (opcional)</label>
                    <input type="file" class="form-control" @change="handleImage" />
                </CCol>
            </CRow>
            <CRow class="mt-3">
                <CCol class="text-right">
                    <CButton color="info" @click="store">
                        Guardar Seguimiento
                    </CButton>
                </CCol>
            </CRow>
        </CForm>
        <!-- === LÍNEA DEL TIEMPO === -->
        <CRow class="mt-4">
        <CCol>
            <h5 class="font-weight-bold mb-3">Historial de Seguimiento</h5>

            <div
            v-for="item in tracking"
            :key="item.id"
            class="timeline-item"
            >
            <div class="timeline-dot"></div>

            <div class="timeline-content">

                <div class="d-flex justify-content-between align-items-start">

                <div>
                    <strong style="font-size:13px;">
                    {{ item.created_at | date }}
                    </strong>
                </div>

                <CButton
                    color="danger"
                    size="sm"
                    variant="ghost"
                    @click="deleteTracking(item.id)"
                >
                    <CIcon name="cil-trash" size="sm" />
                </CButton>

                </div>

                <div class="mt-1" style="font-size:13px;">
                {{ item.comment }}
                </div>

                <div v-if="item.image" class="mt-2">
                <img :src="item.image" style="max-width: 120px; border-radius:4px;" />
                </div>

            </div>
            </div>

        </CCol>
        </CRow>
        <template #footer>
            <CButton color="secondary" @click="closeModal">Cerrar</CButton>
        </template>
    </CModal>
</template>
<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import ws_awards from '../../services/awards'
import store from '../../store'

export default {
    name: 'AwardExchangeTrackingModal',

    data() {
        return {
            showModal: false,
            exchangeId: null,

            form: {
                comment: '',
                image: null
            },

            tracking: [],

            fields: [
                { key: 'created_at', label: 'Fecha' },
                { key: 'comment', label: 'Comentario' },
                { key: 'actions', label: 'Acción' }
            ]
        }
    },
    mixins: [validationMixin],
    validations: {
        form: {
            comment: { required }
        }
    },
    methods: {
        async open(exchangeId) {
            this.exchangeId = exchangeId
            this.showModal = true
            this.form.comment = ''
            this.form.image = null
            await this.getTracking()
        },
        async getTracking() {
            const res = await ws_awards.getTracking(this.exchangeId)
            if (res.type === 'success') {
                this.tracking = res.data
            }
        },
        handleImage(e) {
            this.form.image = e.target.files[0]
        },
        async store() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            this.loading()

            let formData = new FormData()
            formData.append('award_exchange_id', this.exchangeId)
            formData.append('comment', this.form.comment)

            if (this.form.image) {
                formData.append('image', this.form.image)
            }

            const res = await ws_awards.storeTracking(formData)

            if (res.type === 'success') {
                await this.getTracking()
                this.form.comment = ''
                this.form.image = null
            }
            this.loaded();

            this.showToast(res.type, res.message)
        },

        async deleteTracking(id) {
            const res = await ws_awards.deleteTracking({ id })

            if (res.type === 'success') {
                await this.getTracking()
            }

            this.showToast(res.type, res.message)
        },

        closeModal() {
            this.showModal = false
            this.exchangeId = null
            this.$v.$reset()
        },

        showToast(type, message) {
            store.commit('toast', { color: type, message })
        },
        loading() {
            store.commit('loading');
        },
        loaded() {
            store.commit('loaded');
        },
        checkIfValid(field) {
            const f = this.$v.form[field]
            return f.$dirty ? !f.$invalid : null
        }

    },
    computed: {
        isValid() {
            return !this.$v.form.$invalid
        }
    }
}
</script>
<style scoped>
.timeline-item {
    position: relative;
    padding-left: 20px;
    margin-bottom: 15px;
}

.timeline-dot {
    position: absolute;
    left: 0;
    top: 5px;
    width: 10px;
    height: 10px;
    background: #39f;
    border-radius: 50%;
}
</style>
